import ComingSoon from './ComingSoon.component';

export default ComingSoon;
